
import { memo } from "react";
import { IIconsProps } from "./icons.model";

const Cubes = (props: IIconsProps) => {
    return (
        <i id={props.id} className='fa-solid fa-cubes' style={{ fontSize: props.fontSize, color: props.color }} />
    );
};

export default memo(Cubes);
